import { Motorista } from "@/types/motorista";

export const novoMotorista = (): Motorista => {
  return {
    e_estrangeiro: 0,
    cpf_cnpj: "",
    razao_social: "",
    celular: "",
    data_cadastro: "",
    ddi: "",
  };
};
